import showNotification from '../app/notification';

export const notification = {
    error(message: string) {
        showNotification(message, null);
    },
};
